import AssignedRadiologists from "./AssignedRadiologists";

export default AssignedRadiologists